
import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface PaginationItemsPerPageProps {
  itemsPerPage: number;
  onItemsPerPageChange: (value: number) => void;
}

export const PaginationItemsPerPage = ({
  itemsPerPage,
  onItemsPerPageChange
}: PaginationItemsPerPageProps) => {
  return (
    <Select
      value={itemsPerPage.toString()}
      onValueChange={(value) => onItemsPerPageChange(parseInt(value))}
      aria-label="Nombre d'éléments par page"
    >
      <SelectTrigger className="w-[120px] h-8 sm:h-10">
        <SelectValue placeholder="Éléments par page" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="9">9 par page</SelectItem>
        <SelectItem value="18">18 par page</SelectItem>
        <SelectItem value="27">27 par page</SelectItem>
        <SelectItem value="36">36 par page</SelectItem>
      </SelectContent>
    </Select>
  );
};
